export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

export const getToken = () => window.localStorage.getItem('token')

//TODO: No recibir el token y usar siempre getToken()
const fetchApi = async (token: string | null, method: HttpMethod, route: string, body?: any, header?: any, formDataContent?: any) => {
  const headers: HeadersInit = formDataContent === undefined ? { 'Authorization': token ? `Bearer ${token}` : '', 'Content-Type': 'application/json' } :
    header === undefined ? { 'Authorization': token ? `Bearer ${token}` : '' } : { ...header, 'Authorization': token ? `Bearer ${token}` : '' }

  const response = await fetch(`${process.env.REACT_APP_API_URL}/${route}`, {
    method,
    headers,
    body: formDataContent === undefined ? JSON.stringify(body) : body
  })

  // interceptar 401
  if (response.status === 401) {
    const error = new Error('Token expired')
      ; (error as any).status = 401
    throw error
  }

  // respuesta válida
  return formDataContent === undefined
    ? response.json()
    : header === undefined
      ? response.json()
      : response.blob();
}

export default fetchApi
